// extracted by mini-css-extract-plugin
export default {"fadeout":"fadeout-_5WCf"};